var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"mb-4"},[_vm._v("Codesnippets - API")]),_c('CodeSnippets')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }